export const Theme = {
    colors: {
        primaryColor: '#3B448E'
    }
}